// extracted by mini-css-extract-plugin
export default {"CenteredContent":"Registration_CenteredContent__6AhD8","FormWrapper":"Registration_FormWrapper__nFVVU"};